import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All requests carry the session cookie for auth
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// --- Legacy admin token (preserved for /admin/* pages only) ---
export const setAdminToken = (token) => {
  if (token) {
    localStorage.setItem("admin_token", token);
  } else {
    localStorage.removeItem("admin_token");
  }
};

export const getAdminToken = () => localStorage.getItem("admin_token");

api.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token && config.url && config.url.includes("/admin/") && !config.url.endsWith("/admin/login")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
